var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"card-element",attrs:{"id":`card-element-${_vm._uid}`}}),_vm._v(" "),_c('div',{staticClass:"card-errors",attrs:{"id":`card-errors-${_vm._uid}`,"role":"alert"}})]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('div',{attrs:{"id":"payment-request-button"}})])
}]

export { render, staticRenderFns }